import React, { useEffect, useMemo, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Await, defer, useLoaderData } from 'react-router-dom';
import { addGroup, getGroups } from '../../Api Methods/Api';
import GroupsGrid from './GroupsGrid';
import Button1 from '../../components/UI/Button/Button1';
import Modal from '../../components/Modal/Modal';
import InputForm from '../../components/forms/InputFormCreateGroup';
import DataManager from '../../hooks/DataManager';
import StatCard from '../../components/UI/Stats/StatCard';
import DeviceLoadingGrid from '../../components/GridList/DeviceLoadingGrid';
import classes from './GroupsGrid.module.css'
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'
import areYouSureAnim from '../../assets/animations/areYouSure.json'
import { serviceActions } from '../../store/service-Slice';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import Lottie from 'lottie-react';
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from 'primereact/floatlabel';
import { Divider } from 'primereact/divider';
import mixpanel from 'mixpanel-browser';


const Groups = () => {
  const client = useSelector(state => state.auth.client);
  const token = useSelector(state => state.auth.token);
  const role = useSelector(state => state.auth.role);
  const companyName = useSelector(state => state.auth.companyName);
  const [title, setTitle] = useState("Create group");

  const cachedGroups = useSelector(state => state.service.GroupsTableData);
  const [groups, setGroups]  = useState(cachedGroups);
  const groupCreationEnabled = Array.isArray(groups) && groups.find(g => g.name === companyName)?.allowGroupCreation === 1;
  const [modalComponent, setModalComponent] = useState();
  const [name, setName] = useState('')
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [update, setUpdate] = useState(0);
  const [isCreateGroupVisible, setIsCreateGroupVisible] = useState(false)
  const [successVisible, setSuccessVisible] = useState(false)
  const [failVisible, setFailVisible] = useState(false)
  const [failMessage, setFailMessage] = useState("")
  const [confirmVisible, setConfirmVisible] = useState(false)

  const [isLoading, setIsLoadng] = useState(() => {
    return !cachedGroups || cachedGroups.length === 0;
  });    
  const [isLoadingStats, setIsLoadingStats] = useState(true)

  const dataManager = new DataManager();

  const apiData = {
    token,
    client
  }

  useEffect(() => {
  }, [selectedGroup])

  useEffect(() => {
  }, [name])

  const dispatch = useDispatch();

  const HandleGetGroups = async () => {
    const data = await getGroups(apiData, dispatch)
    const sortedData = data.sort((a, b) => a.name.localeCompare(b.name))
    setGroups(sortedData)
    dispatch(serviceActions.setGroupsTableData(sortedData));

    setIsLoadng(false)
    setIsLoadingStats(false)
    localStorage.setItem('groups', JSON.stringify(data));
  }

  useEffect(() => {
    HandleGetGroups()

    mixpanel.track("Groups tab visited", {
      user: localStorage.getItem('email')
    })
  }, [update])

  const ModalDialog = useRef();

  // const handleCreateGroups = () => {
  //   setModalComponent(
  //     <div>
  //     <br/>
  //         <InputForm label={"Enter name of group"} setName={setName}></InputForm>
       
  //       <div>

  //       <Dropdown
  //           value={selectedGroup}
  //           className="w-full md:w-14rem"
  //           style={{ width: '300px' }}  
  //           onChange={(e) => setSelectedGroup(e.value)}
  //           options={groups}
  //           optionLabel="name"
  //           placeholder="Choose group"
  //           filter                 
  //           filterPlaceholder="Search groups..."
  //       />

  //         {/*<Dropdown label={"Please select the parent group below"} dropDownOptions={groupNames} setSelectedGroup={setSelectedGroup} />*/}
  //       </div>
  //       <br></br>
  //       <Button1 onClick={createGroup}>Create</Button1>
  //     </div>
  //   )  
  //   HandleShowModal();
  // }

  const showError = (message) => {
    setModalComponent(
      <div>
        <div>
          <h3>Error</h3>
        </div>
        <br></br>
        <div>
         <p>Error creating group, please try again later.</p>
         <p>{message}</p>
        </div>
        <br></br>
          <Button  icon="pi pi-times" onClick={HandleCloseModal} label="Close" severity='secondary'/>
      </div>
    )  
    HandleShowModal();
  }

  const createGroup = async () => {

    const body = {
      groupName: name, 
      parentID: selectedGroup.id
    }

    if (name !== '' && selectedGroup !== ''){
      const response = await addGroup(apiData, body, dispatch)
      if (response.success){
        HandleGetGroups();
        HandleCloseModal();
        setSuccessVisible(true)
        setIsCreateGroupVisible(false)
      } else {
        setFailMessage(response.msg)
      }
    } else {
      //invalid form
    }
  }

  useEffect(() => {
    if (failMessage !== "") {
      setFailVisible(true)
    }
  }, [failMessage])

  const HandleShowModal = () => {
    ModalDialog.current.open();
  };

  const HandleCloseModal = () => {
    ModalDialog.current.close();
    setTitle("Create group")
  };

  const handleInputChange = (e) => {
    setName(e.target.value);

    /*const timer = setTimeout(() => {
      if (name && (e.target.value !== name)) {
        mixpanel.track("Groups name creation performed", {
            user: localStorage.getItem('email'),
            groupName: e.target.value
        });
      }
    }, 2000);
    return () => clearTimeout(timer);*/
  };

  return ( 
    <>
      <Modal ref={ModalDialog} title={"Create group"} modalName={""} HandleShowModal={HandleShowModal}>
          {modalComponent}
      </Modal>


      <Dialog
          header="Create group"
          visible={isCreateGroupVisible}
          style={{ width: "40vw" }}
          onHide={() => setIsCreateGroupVisible(false)}
          >
          <div>
           <FloatLabel>
              <InputText
                  value={name}
                  onChange={handleInputChange}
              />
              <label htmlFor="ruleName">Name</label>
          </FloatLabel>
          <small>Please note group names must be unique and cannot be changed later</small>
          
          <Divider type="solid"/>

          <p>Choose the parent group from the dropdown below</p>
              <Dropdown 
              value={selectedGroup} 
              onChange={(e) => setSelectedGroup(e.value)} 
              options={groups} 
              optionLabel="name"
              showClear
              filter
              placeholder="Select a group" 
              className="w-full md:w-14rem" />

          </div>

          <br></br>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button icon="pi pi-check" label="Create group" severity="success" disabled={!selectedGroup} onClick={createGroup} />
          </div>
      </Dialog>

        <Dialog
            header="Success"
            visible={successVisible}
            style={{ width: "40vw" }}
            onHide={() => setSuccessVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff"}}>Group created successfully!.</h3>
                <Lottie
                    animationData={successAnim}
                    loop={false}
                    style={{ width: 250, height: 250, margin: "0px" }}
                />

                <Button label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setSuccessVisible(false)}/>
            </div>
        </Dialog>

        <Dialog
            header="Something went wrong"
            visible={failVisible}
            style={{ width: "40vw" }}
            onHide={() => setFailVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie
                    animationData={failAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br/>
                <h3 style={{color:"#6e6e6eff"}}>{failMessage}</h3>
                <br></br>
                <Button  icon="pi pi-times" label="Close" rounded severity="secondary" onClick={() => setFailVisible(false)}/>
            </div>
        </Dialog>

        
      <Await resolve={groups}>
        {(loadedTotalGroups) => 
          <div style={{ display: "flex",  maxWidth:"290px", minWidth:"250px" , alignSelf:"flex-start", alignContent:"start", alignContent:"flex-start"}}>
            {groups && <StatCard title={"Total groups"} value={loadedTotalGroups.length} isLoading={isLoading} />}
          </div>
        }
      </Await>
              

      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "30px", marginTop:"15px"}}>
          {(role === "admin" || role === "TechSupport") && groupCreationEnabled && (
            <Button severity="success" label="Create new group" style={{fontSize: "14px", padding:10}} icon="pi pi-plus" onClick={() => setIsCreateGroupVisible(true)}/>
          )}
        </div>

        {groups ? (
          <GroupsGrid GroupsList={groups} setUpdate={setUpdate} update={update}></GroupsGrid>
        ) : (
          <div style={{ display: "flex", width: "100%" }}>
          <DeviceLoadingGrid
            CardCount={20}
          />
        </div>
        )}
      </div>
    </>
  );
}

export default Groups

export async function loader() {
  const token = localStorage.getItem('token');
  const client = localStorage.getItem('client');

  const apiData = {
    token,
    client
  }

  return defer({
    groups: getGroups(apiData)
  })
}